import * as React from "react";

const Twitter: React.FC = () => {
    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            viewBox="0 0 16 14"
            strokeWidth="2"
            strokeLinecap="round"
            strokeLinejoin="round"
            focusable="false"
            width="24"
            height="24"
            fill="currentColor"
        >
            <path d="M15.943 1.65a6.077 6.077 0 01-1.882.555A3.499 3.499 0 0015.504.26a6.565 6.565 0 01-2.081.856C12.828.428 11.975 0 11.037 0 9.231 0 7.766 1.575 7.766 3.522c0 .273.029.544.083.798-2.713-.14-5.127-1.547-6.74-3.674a3.711 3.711 0 00-.442 1.77c0 1.22.577 2.304 1.456 2.926A3.09 3.09 0 01.64 4.904v.048c0 1.703 1.127 3.124 2.623 3.453-.274.08-.563.116-.864.116-.21 0-.41-.014-.611-.062.414 1.404 1.623 2.423 3.054 2.444A6.248 6.248 0 010 12.361a8.746 8.746 0 005.014 1.588c6.016 0 9.307-5.367 9.307-10.02 0-.148-.003-.299-.01-.45a7.12 7.12 0 001.632-1.829" />
        </svg>
    );
};

export default React.memo(Twitter);
